import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const viewDeadAirMetrics = {
	createViewDeadAirMetrics: (): Metric => {
		return metrics.interaction({
			key: 'ai-mate.view-dead-air',
		});
	},
};
